import * as React from 'react'
import { withTranslation, WithTranslation  } from 'react-i18next'
import { Row, Col } from 'react-bootstrap'

import type { WheelPickerOption } from "@ncdai/react-wheel-picker";
import { WheelPicker, WheelPickerWrapper } from "@ncdai/react-wheel-picker";
import "@ncdai/react-wheel-picker/dist/index.css"
import { FacilityMetricSummary } from '../../../../store/models/domain';
import isEqual from "lodash/isEqual";

interface Props  {
    metric?: FacilityMetricSummary,
    saveLabel: string,
    cancelLabel: string,
    type: string,
    onCancel: () => void,
    onSave: (temp?: string| null, humidity?: string| null) => void,
    t: any
}

const TemperatureMetricModal = (props: Props) => {
    const {
        type,
        metric,
        cancelLabel,
        saveLabel,

        onCancel,
        onSave,    
        // Translate props
        t,
    } = props;

    const [isMounted, setIsMounted] = React.useState(false);
    const [viewType, setViewType] = React.useState(type);

    const [tempChange, setTempChange] = React.useState(false);
    const [tempBtnActive, setTempBtnActive] = React.useState(false);
    const [selectedTemp, setSelectedTemp] = React.useState(['0', '0', '.', '0']);

    const [humidChange, setHumiChange] = React.useState(false);
    const [humidBtnActive, setHumidBtnActive] = React.useState(false);
    const [selectedHumid, setSelectedHumid] = React.useState(['0', '0']);
    
    const setActiveBtn = (selected: string) => {
        //add logic if btn is/was activated, enable saving
        if (selected === 'temperature') setTempBtnActive(true)
        else setHumidBtnActive(true)
    }

    React.useEffect(() => {
        setActiveBtn(type)
        setIsMounted(true);
    }, []);

    React.useEffect(() => {
        const currentTempValue = metric?.temperature?.value || "00.0"
        const values = currentTempValue.split("")
        setSelectedTemp(values)
    }, [])


    React.useEffect(() => {
        const currentHumidValue = metric?.humidity?.value || "00"
        const values = currentHumidValue.split("")
        setSelectedHumid(values)
    }, [])

    React.useEffect(() => {
        // if values changed, use the corpotate teal color for the label
        setTempChange(!isEqual(selectedTemp.join(''), metric?.temperature?.value));
    }, [selectedTemp])

    React.useEffect(() => {
        // if values changed, use the corpotate teal color for the label
        setHumiChange(!isEqual(selectedHumid.join(''), metric?.humidity?.value));
    }, [selectedHumid])

    if (!isMounted) return null;

    const createArray = (length: number, add = 0): WheelPickerOption<number>[] =>
        Array.from({ length }, (_, i) => {
            const value = --i + add;
            return {
                label: value.toString(),
                value: value,
            };
        });
    
    const tempOptions = createArray(10, 1);
    const _onSave = () => {
        // saving is depending if the btn was activated regardless if the values are changed/not
        const temp = tempBtnActive ? selectedTemp.join('') : ""
        const humidity = humidBtnActive ? selectedHumid.join('') : ""

        onSave(temp, humidity)
        
    }

    const onToggleView = (type: string) => {
        if (type === viewType) return null

        setViewType(type)
        setActiveBtn(type)
    }

    

    const _onValueChange = (val: number, index: number, type: string) => {
        if (type === 'temp') {
            setSelectedTemp(prev => {
                const next = [...prev];
                next[index] = val.toString();
                return next;
            });
            
        } else {
            setSelectedHumid(prev => {
                const next = [...prev];
                next[index] = val.toString();
                return next;
            });
        }
    }

    return (
        <div className="room-temp-main-container">
            <Row>
                <Col sm={12} md={12} className='pt-3'>                    
                    <div className="d-flex justify-content-around align-items-center ml-2">
                        <div className='d-flex flex-column'>
                            <div className="mb-2">{t("Temperature")}</div>
                            <div className="d-flex align-items-center">
                                <button className={`mr-2 room-temp-toggle-btn ${viewType === "temperature" ? "active" : ""}`} onClick={() => onToggleView('temperature') } title="Click to toggle">
                                    <i className="bi bi-thermometer-sun"></i>
                                </button>
                                {(viewType === "temperature" || tempBtnActive) &&
                                    <span className={`room-temp-toggle-value ${tempChange ? "active" : ""}`}>{selectedTemp.join('')}</span>
                                }
                            </div>
                            
                        </div>
                        <div className='d-flex flex-column'>
                            <div className="mb-2">{t("Humidity")}</div>
                            <div className="d-flex align-items-center">
                                <button className={`mr-2 room-temp-toggle-btn ${viewType === "humidity" ? "active" : ""}`} onClick={() => onToggleView('humidity')} title="Click to toggle">
                                    <i className="bi bi-moisture"></i>
                                </button>
                                {(viewType === "humidity" || humidBtnActive) &&
                                    <span className={`room-temp-toggle-value ${humidChange ? "active" : ""}`}>{selectedHumid.join('')}</span>
                                }
                            </div>
                             
                        </div>
                        
                    </div> 
                </Col>
            </Row>
            <Row className="justify-content-center pt-4">
                {viewType === 'temperature' ? (
                    <div className="pt-2" style={{ overflow: 'visible', height: '200px', width: 210 }}>
                        <WheelPickerWrapper className="temp-wheel-picker temeperature">
                            <WheelPicker options={tempOptions} value={parseInt(selectedTemp[0])} infinite onValueChange={(val) => _onValueChange(val, 0, 'temp')} />
                            <WheelPicker options={tempOptions} value={parseInt(selectedTemp[1])} infinite onValueChange={(val) => _onValueChange(val, 1, 'temp')} />
                            <div className="decimal-point-wrapper">
                                <div className="decimal-point">.</div>
                            </div>
                            <WheelPicker options={tempOptions} value={parseInt(selectedTemp[3])} infinite onValueChange={(val) => _onValueChange(val, 3, 'temp')} />
                        </WheelPickerWrapper>
                    </div>
                ) : (
                    <div className="pt-2" style={{ overflow: 'visible', height: '200px', width: 150 }}>
                        <WheelPickerWrapper className="temp-wheel-picker humidity">
                            <WheelPicker options={tempOptions} value={parseInt(selectedHumid[0])} infinite onValueChange={(val) => _onValueChange(val, 0, 'humid')} />
                            <WheelPicker options={tempOptions} value={parseInt(selectedHumid[1])} infinite onValueChange={(val) => _onValueChange(val, 1, 'humid')} />
                        </WheelPickerWrapper>
                    </div>
                )}
            </Row>
            <Row>
                <Col sm={12} md={12} className='pt-4'>                    
                    {/* Mimik sweetalert2 buttons */}
                    <div className="d-flex justify-content-between ml-2 pt-3">                                
                        <button className="btns-v2 cancel-btn"  onClick={() => { onCancel() }}>{t(cancelLabel)}</button>
                        <button className="btns-v2 save-btn" onClick={() => _onSave() }>{t(saveLabel)}</button>
                    </div> 
                </Col>
            </Row>
        </div>
        
    )
}

const translate = withTranslation()
export default translate(TemperatureMetricModal)
